import DependencyLoader from "../DependencyLoader";
import makeMeasure from "../util/makeMeasure";
import PerformanceMonitor from "../util/monitoring/PerformanceMonitor";

const ER_SCRIPT_NAME = "event-recorder-client.min.js";
const ER_SRC = `${ process.env.ASSETS_DOMAIN }/s3/foundation/event-recorder-client/1.0/${ ER_SCRIPT_NAME }`;

type EventRecorderLoaderProps = {
    enabled?: boolean;
    application?: string;
    scriptUrl?: string;
}

export class EventRecorderLoader extends DependencyLoader {

    private performanceMonitor = new PerformanceMonitor("Sparkle:EventRecorder");
    private measure = makeMeasure(this.performanceMonitor);
    private options: EventRecorderLoaderProps;

    constructor(options: EventRecorderLoaderProps) {
        super();
        this.options = options;
    }

    init() {
        if (!this.options.enabled) return;
        this.initClient(this.options.application);
        this.measure(
            "loadEventRecorder",
            () => this.loadScriptDependency(this.options.scriptUrl ?? ER_SRC)
        ).catch((e) => {
            console.error(`Error loading EventRecorder script: ${ e }`);
        });
    }

    private initClient(application?: string) {
        const appName = application ?? "sparkle";
        const current = Date.now();

        window.eventRecorder.cmd.push(() => {
            const eventRecorder = window.getEventRecorderClient(appName);

            // handle cases where first event doesn't come from sparkle and appname is undefined
            if (eventRecorder.application === "undefined") {
                eventRecorder.application = appName;
            }

            eventRecorder.fireEvent("PageLoaded", {}, {}, current);
        });
    }

}
